<template>
  <div>
    <h1>home</h1>
  </div>
</template>

<script>
export default {
  name: "Home"
}
</script>

<style scoped>

</style>